import useTopPanel from 'hooks/useTopPanel';
import { memo, useEffect } from 'react';
import CRMBlockColumns from './crm-parts/block-columns/CRMBlockColumns';
import CRMTopPanel from './crm-parts/top-panel/CRMTopPanel';
import usePermission from 'hooks/usePermission';
import { t } from 'i18next';

const CRM = () => {
  const { setComponent } = useTopPanel();
  const { hasPermission } = usePermission();

  useEffect(() => {
    setComponent(t('sidebar.admin.crm'));

    return () => setComponent('');
  }, []);

  return (
    <div className='component-list-wrapper rounded-lg'>
      <CRMTopPanel
        addBlock={hasPermission('CRM_ADD_BLOCK')}
        addLead={hasPermission('')}
      />
      <div className='crm-wrapper'>
        <CRMBlockColumns />
      </div>
    </div>
  );
};
export default memo(CRM);
